import {
  required,
  requiredIf,
  numeric,
  minLength,
  maxLength,
  helpers,
  email,
  minValue,
  maxValue,
  sameAs,
  url,
} from 'vuelidate/lib/validators'

const regexNumericComma = helpers.regex('alpha', /^(\d*\W*)+$/)
// const integer = helpers.regex('alpha', /^[0-9]+$/)
const regexNumericDot = helpers.regex('alpha', /^[0-9]*[.]?[0-9]+$/)
const oneDecimalPlaces = helpers.regex('alpha', /(^[0-9]*$)|(^[0-9]*(\.\d{1}))+$/)
const regexLetters = helpers.regex('alpha', /^[а-щА-ЩЬьЮюЯяЇїІіЄєҐґ'.\‘\’\- ]*$/)
const regexLetterNumber = helpers.regex('alpha', /^[а-щА-ЩЬьЮюЯяЇїІіЄєҐґ0-9\-]*$/)
const regexLetterNumberEng = helpers.regex('alpha', /^[a-zA-Z0-9\-]*$/)
const innLength = helpers.regex('alpha', /^[0-9]{10}([0-9]{2})?$/)
const address = helpers.regex('alpha', /^[а-щА-ЩЬьЮюЯяЇїІіЄєҐґ0-9\s,.'-/ ]*$/)
const orderNumber = helpers.regex('alpha', /^[0-9\s,.'-/№]*$/)
const registrationNumber = helpers.regex('alpha', /^[a-zA-Zа-щА-ЩЬьЮюЯяЇїІіЄєҐґ0-9\-]*$/)
const accreditationCertificateNumber = helpers.regex('alpha', /^[a-zA-Zа-щА-ЩЬьЮюЯяЇїІіЄєҐґ0-9\s/№]*$/)
const listCategoriesToCountTheAxles = [11, 12, 13, 14, 15, 16, 17]
const nameOrganization = helpers.regex('alpha', /^[IVXа-щА-ЩЬьЮюЯяЇїІіЄєҐґ0-9\s,.'-/«».,():’— №!";*]*$/)
const textNote = helpers.regex('alpha', /^[IVXа-щА-ЩЬьЮюЯяЇїІіЄєҐґ0-9\s,.'-/«».,():’— №!";*]*$/)
const regexVinCode = helpers.regex('alpha', /^[0123456789abcdefghjklmnprstuvwxyzABCDEFGHJKLMNPRSTUVWXYZ]+$/)
const regexNoSpace = helpers.regex('alpha', /^[^\s]+$/)
const seatBeltMarking = helpers.regex('alpha', /^[a-zA-ZЕ0-9-/*:\s]*$/)
const numbersAndSymbols = helpers.regex('alpha', /^[0-9.-]*$/)
const serial = helpers.regex('alpha', /^[A-ZА-ЩЬЮЯЇІЄҐ0-9]*$/)
const declaration = helpers.regex('alpha', /(^[0-9]*$)|(^[0-9]*(_mti$))/)
const floatNumber = helpers.regex('alpha', /^-?([0-9]{1,3})*[.]?([0-9]{1,3})+$/)

const invalidFormat = value => value !== 'Invalid date'

const onlyTrue = required => value => {
  if (!required) return true
  return !!value
}

const multipleFive = value => value % 5 === 0

export const signIn = {
  email: { required, email },
  password: { required }
}

export const forgotPassword = {
  email: { required, email }
}

export const vehicle = context => {
  return {
    vehicle_type: { required },
    purpose: {
      required: requiredIf(() => context.isSpecialPurposeVehicleType),
      maxLength: maxLength(140)
    },
    vehicle_condition: { required },
    vehicle_mark: { required },
    code_uktzed: { required, numeric, maxValue: maxValue(32767) },
    vehicle_model: { required: requiredIf(() => !context.isKtzWithoutModel) },
    vehicle_modification: {
      required: requiredIf(() => context.vehicleModificationList.length)
    },
    production_year: {
      required,
      numeric,
      minValue (value) { return new Date(value) >= new Date('1988') },
      maxValue (value) { return new Date(value) <= new Date() },
      minLength: minLength(4)
    },
    vehicle_fuel_type: { required: requiredIf(() => !context.isTrailer) },
    engine_capacity: {
      required: requiredIf(() => !context.isTrailer && !context.isFuelTypeElectric),
      numeric,
      maxValue: maxValue(32767)
    },
    engine_euro_rate: { required: requiredIf(() => !context.isTrailer && !context.isMotorcycle) },
    euro_code: {
      required: requiredIf(() => !context.isTrailer && !context.isMotorcycle &&
        context.showEuroCode && !context.disabledEuroCode)
    },
    presence_brake_system: { required: requiredIf(() => context.isTrailer) },
    legal_act_for_euro_rate: {
      required: requiredIf(() => !context.isTrailer && !context.isMotorcycle &&
        context.showEuroCode && !context.disabledLegalActs)
    },
    can_transport_dangerous_good: { required: requiredIf(() => context.showIsCanTransportDangerousGood) },
    gross_weight: {
      required,
      numeric,
      maxValue: maxValue(999999)
    }
  }
}

export const techControlStatementVehicle = context => {
  return {
    vehicle_type: { required },
    vehicle_mark: { required },
    vehicle_model: { required: requiredIf(() => !context.isKtzWithoutModel) },
    vehicle_modification: {
      required: requiredIf(() => context.vehicleModificationList.length)
    },
    production_year: {
      required,
      numeric,
      minValue (value) { return new Date(value) >= new Date('1988') },
      maxValue (value) { return new Date(value) <= new Date() },
      minLength: minLength(4)
    },
    additional_vin_code: {
      required: requiredIf(() => context.isVinCodeDifferent),
      regexVinCode,
      minLength: minLength(9),
      maxLength: maxLength(12)
    },
    vehicle_fuel_type: { required: requiredIf(() => !context.isTrailer) },
    engine_capacity: {
      required: requiredIf(() => !context.isTrailer && context.showCarEngineCapacity),
      numeric
    },
    vehicle_transmission_type: { required: requiredIf(() => !context.isTrailer) },
    engine_euro_rate: { required: requiredIf(() => !context.isTrailer) },
    registration_number: { required, registrationNumber, minLength: minLength(5), maxLength: maxLength(10) },
    presence_brake_system: { required: requiredIf(() => context.isTrailer) }
  }
}

export const addressSearch = context => {
  return {
    index: { required: requiredIf(() => context.isRequiredIndex), numeric, maxLength: maxLength(5) },
    region: { required: requiredIf(() => context.isRequiredForm) },
    type_street: { required: requiredIf(() => context.isRequiredForm) },
    street: { required: requiredIf(() => context.isRequiredForm), address },
    house: { required: requiredIf(() => context.isRequiredForm), address },
    city: { required: requiredIf(() => context.isRequiredForm), numeric }
  }
}

export const client = context => {
  return {
    first_name_ukr: { required, regexLetters },
    middle_name_ukr: { regexLetters },
    last_name_ukr: { required, regexLetters },
    date_birth: {
      required: requiredIf(() => !context.isLegalEntity),
      minValue (value) {
        if (!context.isLegalEntity) {
          return new Date(value) > new Date('1900-01-01') && context.getAge(value) >= 14
        }
        return true
      },
      maxValue (value) {
        if (!context.isLegalEntity) {
          return new Date(value) < new Date()
        }
        return true
      }
    },
    client_contacts: {
      email: { required, email }
    },
    organization: {
      EDPROU: {
        required: requiredIf(() => context.isLegalEntity),
        numeric,
        minLength: minLength(8),
        maxLength: maxLength(8)
      },
      organization_name: { required: requiredIf(() => context.isLegalEntity) },
      organization_type: { required: requiredIf(() => context.isLegalEntity) }
    },
    trustee: {
      last_name_ukr: { required: requiredIf(() => context.isTrustedPerson), regexLetters },
      first_name_ukr: { required: requiredIf(() => context.isTrustedPerson), regexLetters },
      middle_name_ukr: { regexLetters },
      date_birth: {
        required: requiredIf(() => context.isTrustedPerson),
        minValue (value) {
          if (context.isTrustedPerson) {
            return new Date(value) > new Date('1900-01-01') && context.getAge(value) >= 14
          }
          return true
        },
        maxValue (value) {
          if (context.isTrustedPerson) {
            return new Date(value) < new Date()
          }
          return true
        }
      },
      email: { required: requiredIf(() => context.isTrustedPerson), email }
    }
  }
}

export const passport = context => {
  return {
    inn: {
      required: requiredIf(() => !context.isNotUserITN),
      numeric,
      innLength
    }
  }
}

export const selectOrganization = context => {
  return {
    organization: { required },
    agencyInOrganization: { required: requiredIf(() => context.access('auditorCertification')) }
  }
}

export const currentStand = {
  currentStand: { required }
}

export const paramsLightMeasurement = context => {
  return {
    distance_for_normative: { required, regexNumericDot, minValue: minValue(0), maxValue: maxValue(2147483647) },
    headlight_type: { required },
    fog_distance_for_normative: {
      required: requiredIf(() => context.body.has_fog_light),
      regexNumericDot, minValue: minValue(0), maxValue: maxValue(2147483647)
    }
  }
}

export const vehicleForBrakeMeasurement = {
  manufacturer_id: { required },
  model_id: { required },
  vehicle_type_id: { required },
  category_id: { required },
  issue_year: { required },
  axis_number: { required },
  mass: { required },
  fuel_type_id: { required },
  car_license_plate: { required },
  engine_volume: { required },
  color_id: { required },
  odometr: { required }
}

export const ownerForBrakeMeasurement = {
  name: { required },
  owner_code: { required }
}

export const settingsStandBrakeForce = {
  platform: { required },
  referent_weight: { required, regexNumericComma }
}

export const settingsStandCalibrationWeight = {
  referent_weight: { required, regexNumericComma }
}

export const standCharacteristics = {
  speed_limit: { required, regexNumericDot },
  left_shaft_diameter: { required, regexNumericDot },
  right_shaft_diameter: { required, regexNumericDot },
  left_pulse_per_round: { required, numeric },
  right_pulse_per_round: { required, numeric },
  min_weight_value: { required, numeric },
  max_weight_value: { required, numeric },
  left_brake_factor: { required, regexNumericDot },
  right_brake_factor: { required, regexNumericDot },
  total1_weight_factor: { required, regexNumericDot },
  arm_force_factor: { required, regexNumericDot },
  pedal_force_factor: { required, regexNumericDot }
}

export const standSettings = {
  stand: { required },
  stand_name: { required }
}

export const inspection = context => {
  return {
    vehicle: {
      vehicle_mark_type: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'vehicle_mark_type' && i.is_required))
      },
      vehicle_variant: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'vehicle_variant' && i.is_required))
      },
      vehicle_version: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'vehicle_version' && i.is_required))
      },
      code_uktzed: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'code_uktzed' && i.is_required)),
        numeric
      },
      vehicle_mark: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'vehicle_mark' && i.is_required))
      },
      vehicle_model: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'vehicle_model' && i.is_required) &&
          !context.isKtzWithoutModel
        )
      },
      vehicle_modification: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'vehicle_modification' &&
            i.is_required && context.vehicleModificationList.length))
      },
      vehicle_category: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'vehicle_category' && i.is_required))
      },
      carcass_type: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'carcass_type' && i.is_required))
      },
      has_carcass: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'has_carcass' && i.is_required))
      },
      count_doors: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'count_doors' && i.is_required)),
        numeric,
        maxValue: maxValue(100)
      },
      door_location: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'door_location' && i.is_required))
      },
      count_seats: {
        numeric,
        required:
          requiredIf(() =>
            context.dependency?.dependency_fields.some(i => i.field_name === 'count_seats' && i.is_required)),
        maxValue: maxValue(100)
      },
      count_crew_members_seats: {
        numbersAndSymbols,
        required:
          requiredIf(() =>
            context.dependency?.dependency_fields.some(i => i.field_name === 'count_crew_members_seats' && i.is_required)),
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) <= 100
          }
          return true
        }
      },
      count_priority_seats: {
        numbersAndSymbols,
        required:
          requiredIf(() =>
            context.dependency?.dependency_fields.some(i => i.field_name === 'count_priority_seats' && i.is_required)),
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) <= 100
          }
          return true
        }
      },
      count_stationary_seats: {
        numbersAndSymbols,
        required:
          requiredIf(() =>
            context.dependency?.dependency_fields.some(i => i.field_name === 'count_stationary_seats' && i.is_required)),
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) <= 100
          }
          return true
        }
      },
      count_upper_tier_seats: {
        numbersAndSymbols,
        required:
          requiredIf(() =>
            context.dependency?.dependency_fields.some(i => i.field_name === 'count_upper_tier_seats' && i.is_required)),
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) <= 100
          }
          return true
        }
      },
      count_lower_tier_seats: {
        numbersAndSymbols,
        required:
          requiredIf(() =>
            context.dependency?.dependency_fields.some(i => i.field_name === 'count_lower_tier_seats' && i.is_required)),
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) <= 100
          }
          return true
        }
      },
      count_passengers_wheelchairs_seats: {
        numbersAndSymbols,
        required:
          requiredIf(() =>
            context.dependency?.dependency_fields.some(i => i.field_name === 'count_passengers_wheelchairs_seats' &&
              i.is_required)),
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) <= 100
          }
          return true
        }
      },
      manufacturer_country: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'manufacturer_country' && i.is_required))
      },
      identification_method: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'identification_method' && i.is_required))
      },
      identification_place: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'identification_place' && i.is_required))
      },
      count_axles: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'count_axles' && i.is_required)),
        numeric,
        maxValue: maxValue(listCategoriesToCountTheAxles.includes(context.body.vehicle.vehicle_category) ? 2 : 20)
      },
      count_wheels: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'count_wheels' && i.is_required)),
        numeric,
        countWheels (value) { return value >= context.body.vehicle.count_axles },
        maxValue: maxValue(80)
      },
      vehicle_drive: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'vehicle_drive' && i.is_required))
      },
      drive_axles_numbers: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'drive_axles_numbers' && i.is_required))
      },
      controlled_axles_numbers: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'controlled_axles_numbers' && i.is_required))
      },
      steering_type: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'steering_type' && i.is_required))
      },
      steering_boost_method: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'steering_boost_method' && i.is_required))
      },
      count_fuel_tanks: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'count_fuel_tanks' && i.is_required)),
        numeric,
        maxValue: maxValue(20)
      },
      count_silencers: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'count_silencers' && i.is_required)),
        numeric,
        maxValue: maxValue(20)
      },
      wheel_formula: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'wheel_formula' && i.is_required))
      },
      steering_wheel_location: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'steering_wheel_location' && i.is_required))
      },
      boot_space_length: {
        numbersAndSymbols
      },
      load_axles_number: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'load_axles_number' && i.is_required))
      },
      trailer_type_brake_connector: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'trailer_type_brake_connector' && i.is_required))
      },
      // distance_between_axes: {
      //   required: requiredIf(() =>
      //   context.dependency?.dependency_field
      //   .some(i => i.field_name === 'distance_between_axes' &&
      //   i.is_required) &&
      //     context.body.vehicle.count_axles >= 3),
      //   regexNumericComma
      // },
      length: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'length' && i.is_required)),
        numbersAndSymbols,
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) < 50000
          }
          return true
        }
      },
      width: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'width' && i.is_required)),
        numbersAndSymbols,
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) < 20000
          }
          return true
        }
      },
      height: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'height' && i.is_required)),
        numbersAndSymbols,
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) < 20000
          }
          return true
        }
      },
      weight: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'weight' && i.is_required)),
        numbersAndSymbols,
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) < 999999
          }
          return true
        }
      },
      gross_weight: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'gross_weight' && i.is_required)),
        numbersAndSymbols,
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) < 999999
          }
          return true
        }
      },
      max_combine_weight: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'max_combine_weight' && i.is_required)),
        numbersAndSymbols,
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) < 999999
          }
          return true
        }
      },
      transmission_type: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'transmission_type' && i.is_required))
      },
      engine_location: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'engine_location' && i.is_required))
      },
      engine_pollution_reduction: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'engine_pollution_reduction' && i.is_required))
      },
      engine_cooling_system: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'engine_cooling_system' && i.is_required))
      },
      engine_euro_rate: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'engine_euro_rate' && i.is_required))
      },
      engine_manufacturer: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'engine_manufacturer' && i.is_required))
      },
      engine_code: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'engine_code' && i.is_required))
      },
      engine_working_principle: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'engine_working_principle' && i.is_required))
      },
      count_cylinders: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'count_cylinders' && i.is_required)),
        numeric
      },
      cylinder_arrangement: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'cylinder_arrangement' && i.is_required))
      },
      engine_capacity: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'engine_capacity' && i.is_required)),
        numbersAndSymbols
      },
      fuel_type: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'fuel_type' && i.is_required))
      },
      gas_type: {
        required: requiredIf(() =>
          context.isViewGasType)
      },
      distance_between_balloon_and_road: {
        required: requiredIf(() =>
          context.isViewDistanceBetweenDalloonAndRoad),
        numeric
      },
      horse_power: {
        required: requiredIf(() => context.convertHorsePowerToKw),
        regexNumericDot,
        maxValue: maxValue(13409)
      },
      engine_power: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'engine_power' && i.is_required) &&
          !context.isFuelTypeOnlyElectric
        ),
        numbersAndSymbols,
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) < 9999
          }
          return true
        }
      },
      electric_engine_power: {
        required: requiredIf(() => context.isFuelTypeElectric),
        numbersAndSymbols,
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) < 9999
          }
          return true
        }
      },
      engine_rpm: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'engine_rpm' && i.is_required) &&
          !context.isFuelTypeOnlyElectric
        ),
        numbersAndSymbols,
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) < 30000
          }
          return true
        }
      },
      max_speed: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'max_speed' && i.is_required)),
        numbersAndSymbols,
        maxValue (value) {
          if (!String(value).includes('-')) {
            return Number(value) < 999
          }
          return true
        }
      },
      count_standing_places: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'count_standing_places' && i.is_required))
      },
      vehicle_class: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'vehicle_class' && i.is_required))
      },
      count_drive_axles: {
        numeric,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'count_drive_axles' && i.is_required))
      },
      count_controlled_axles: {
        numeric,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'count_controlled_axles' && i.is_required))
      },
      displacement_saddle_coupling_device_max: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields
            .some(i => i.field_name === 'displacement_saddle_coupling_device_max' && i.is_required))
      },
      displacement_saddle_coupling_device_min: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'displacement_saddle_coupling_device_min'
            && i.is_required))
      },
      distance_between_front_and_coupling_device: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields
            .some(i => i.field_name === 'distance_between_front_and_coupling_device' && i.is_required))
      },
      posterior_overhang: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'posterior_overhang' && i.is_required))
      },
      permissible_weight: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'permissible_weight' && i.is_required))
      },
      is_registration_permissible_weight: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields
            .some(i => i.field_name === 'is_registration_permissible_weight' && i.is_required))
      },
      max_combine_weight_legal: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'max_combine_weight_legal' && i.is_required))
      },
      coupling_device_static_weight: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'coupling_device_static_weight' &&
            i.is_required))
      },
      is_registration_max_combine_weight_legal: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields
            .some(i => i.field_name === 'is_registration_max_combine_weight_legal' && i.is_required))
      },
      axis_drive_pneumatic_suspension: {
        required: requiredIf(() =>
          context.dependency?.dependency_fields
            .some(i => i.field_name === 'axis_drive_pneumatic_suspension' && i.is_required))
      },
      distance_between_back_and_coupling_device: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'distance_between_back_and_coupling_device' &&
            i.is_required))
      },
      coupling_device_max_weight: {
        numeric,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'coupling_device_max_weight' && i.is_required))
      },
      trailer_max_weight_with_brakes: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'trailer_max_weight_with_brakes' &&
            i.is_required))
      },
      semi_trailer_weight: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'semi_trailer_weight' && i.is_required))
      },
      movable_coupling_device_max_weight: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'movable_coupling_device_max_weight' &&
            i.is_required))
      },
      static_coupling_device_max_weight: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'static_coupling_device_max_weight' &&
            i.is_required))
      },
      trailer_max_weight_without_brakes: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'trailer_max_weight_without_brakes' &&
            i.is_required))
      },
      ratio_engine_power_to_weight: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'ratio_engine_power_to_weight' &&
            i.is_required))
      },
      coupling_device_weight: {
        numbersAndSymbols,
        required: requiredIf(() =>
          context.dependency?.dependency_fields.some(i => i.field_name === 'coupling_device_weight' && i.is_required))
      },
    },
    production_year: {
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'production_year' && i.is_required)),
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4),
      minValue (value) { return new Date(value.toString()) >= new Date('1988') },
      maxValue (value) { return new Date(value.toString()) <= new Date() }
    },
    vehicle_color: {
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'vehicle_color' && i.is_required))
    },
    vehicle_miles: {
      required: requiredIf(() => context.convertMilesToKilometers),
      regexNumericDot
    },
    vehicle_mileage: {
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'vehicle_mileage' && i.is_required)),
      numbersAndSymbols
    },
    total_angular_distance: {
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'total_angular_distance' && i.is_required)),
      numeric
    },
    flashing_frequency_turn_signal: {
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'flashing_frequency_turn_signal' && i.is_required)),
      maxValue: maxValue(9999),
      numeric
    },
    is_international_permissible_weight: {
      required: requiredIf(() =>
        context.dependency?.dependency_fields
          .some(i => i.field_name === 'is_international_permissible_weight' && i.is_required))
    },
    pressure_in_brake_trailer: {
      numbersAndSymbols,
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'pressure_in_brake_trailer' && i.is_required))
    },
    coupling_device_number: {
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'coupling_device_number' && i.is_required))
    },
    can_transport_dangerous_good: {
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'can_transport_dangerous_good' && i.is_required))
    },
    laboratory_temperature: { required, floatNumber },
    relative_humidity: { required, numeric },
    weather_temperature: { required, floatNumber },
    weather_pressure: { required, regexNumericDot },
    weather_humidity: { required, numeric },
    weather_wind_speed: { required, numeric }
  }
}

export const noteForTypeCertificate = {
  note: { required, textNote }
}
export const clientStatement = {
  reject: { required },
  dateReview: {
    body: {
      date_inspection: { required },
      comment: { required },

    }
  }
}
export const registrationAxisPermissibleWeight = context => {
  return {
    is_registration_axis_permissible_weight: {
      required: requiredIf(() =>
        context.dependency?.dependency_fields
          .some(i => i.field_name === 'is_registration_axis_permissible_weight' && i.is_required))
    }
  }
}

export const registrationGroupMaxWeightPermissible = context => {
  return {
    is_registration_group_max_weight_permissible: {
      required: requiredIf(() =>
        context.dependency?.dependency_fields
          .some(i => i.field_name === 'is_registration_group_max_weight_permissible' && i.is_required))
    }
  }
}

export const countGroup = {
  groupCount: { required, numeric }
}

export const certificationAgency = {
  certification_agency: { required }
}

export const vehicleCategory = context => {
  return {
    vehicle_category: { required },
    euro_code: { required: requiredIf(() => context.showInputsEuroRates) },
    engine_euro_rate: { required },
    legal_act_for_euro_rate: { required: requiredIf(() => context.showInputsEuroRates) }
  }
}

export const axis = context => {
  return {
    weight_distribution: {
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'weight_distribution' && i.is_required)),
      numbersAndSymbols,
      minValue (value) {
        if (!String(value).includes('-') && value) {
          return Number(value) > 0
        }
        return true
      }
    },
    axis_track: {
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'axis_track' && i.is_required)),
      numbersAndSymbols,
      minValue (value) {
        if (!String(value).includes('-') && value) {
          return Number(value) > 0
        }
        return true
      }
    },
    distance_between_axes: {
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'distance_between_axes' && i.is_required) &&
        context.axisIndex !== (context.allAxis.length - 1)),
      numbersAndSymbols,
      minValue (value) {
        if (value && !String(value).includes('-')) {
          return Number(value) > 0
        }
        return true
      }
    },
    equipped_weight_distribution: {
      numbersAndSymbols,
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'equipped_weight_distribution' && i.is_required))
    },
    axis_permissible_weight: {
      numbersAndSymbols,
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'axis_permissible_weight' && i.is_required)),
      minValue (value) {
        if (!String(value).includes('-')) {
          if (
            context.dependency?.dependency_fields.some(i => i.field_name === 'axis_permissible_weight') &&
            value > 0 &&
            context.axis.weight_distribution !== '-'
          ) {
            return value >= context.axis.weight_distribution
          }
          return true
        }
        return true
      }
    }
  }
}

export const tire = () => {
  return {
    tire_width: { required, numeric, minValue: minValue(1), multipleFive },
    tire_height: { required, numeric, minValue: minValue(1), multipleFive },
    diameter: { required, minValue: minValue(1), regexNumericDot },
    tire_tread_height: {
      required,
      regexNumericDot
    },
    pressure: {
      required,
      oneDecimalPlaces,
      minValue: minValue(0)
    }
  }
}

export const window = context => {
  return {
    window_type: { required },
    serial_number: { required: requiredIf(() => !context.isInspectionTechnicalControl) }
  }
}

export const headlight = context => {
  return {
    color: { required: requiredIf(() => !!Number(context.headlight.count)) },
    in_stock: { required: requiredIf(() => context.isShowStockForm) },
    count: {
      required: requiredIf(() => !context.isShowStockForm),
      minValue: minValue(0),
      maxValue (value) {
        if (context.maxCountHeadlight) {
          return value <= context.maxCountHeadlight
        }
        return true
      }
    }
  }
}

export const headlightSerial = context => {
  return {
    serial: {
      required: requiredIf(() => !!(context.count && parseInt(context.count)))
    }
  }
}

export const seats = {
  counts: {
    count_rows: { required }
  },
  seatPosition: {
    position: { required }
  }
}

export const seatBelt = context => {
  return {
    amount_identical_belts: {
      required: requiredIf(() => context.isShowAddCertainAmountSeatBelts),
      numeric,
      maxValue () {
        if (context.isShowAddCertainAmountSeatBelts) {
          return context.amountMachinesIsExceeded
        } else {
          return true
        }
      }
    },
    serial_number: { required, seatBeltMarking },
    number_attachment_points: { required },
    seat_position: { required },
    belt_category: { required }
  }
}

export const axisGroup = context => {
  return {
    count_axis_in_group: {
      numeric,
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'count_axis_in_group' && i.is_required))
    },
    group_weight_distribution: {
      numbersAndSymbols,
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'group_weight_distribution' && i.is_required))
    },
    group_max_weight_permissible: {
      numbersAndSymbols,
      required: requiredIf(() =>
        context.dependency?.dependency_fields.some(i => i.field_name === 'group_max_weight_permissible' && i.is_required))
    }
  }
}

export const vinCode = {
  number: { required }
}

export const currentDeclaration = {
  // currentDeclaration: { required, numeric }
  currentDeclaration: { required, declaration }
}

export const selectEquipment = {
  equipment: { required }
}

export const currentTypeMeasurement = {
  currentTypeMeasurement: { required }
}

export const oilTemperatureZigbeeMeasurement = {
  oilTemperature: { required, numbersAndSymbols }
}

export const gasMeasurementForZigBee = {
  neutralizer: { required },
  rMinAndRMax: context => {
    return {
      rpm: {
        required: requiredIf(() =>
          (context?.resultMeasurement.r_min_co_level && !context?.resultMeasurement.r_min_rpm) ||
          (context?.resultMeasurement.r_max_co_level && !context?.resultMeasurement.r_max_rpm)
        ),
        numeric
      },
      temperature: {
        required: requiredIf(() =>
          (context?.resultMeasurement.r_min_co_level && !context?.resultMeasurement.r_min_temperature) ||
          (context?.resultMeasurement.r_max_co_level && !context?.resultMeasurement.r_max_temperature)
        ),
        regexNumericDot
      }
    }
  }
}

export const settingsStandCalibrationSensors = {
  referent_weight: { required, regexNumericComma },
  platform: { required }
}

export const signatureKey = {
  key: { required },
  password: { required }
}

export const letterStatementNAAU = context => {
  return {
    legal_name: { required },
    type_cab: { required },
    name_cab: { required },
    address: { required },
    first_name_ukr: { required },
    middle_name_ukr: { required },
    last_name_ukr: { required },
    register_number: { required: requiredIf(() => context.accreditationType === 'primary') },
    certificate_number: {
      required: requiredIf(() => context.accreditationType === 'secondary'),
      accreditationCertificateNumber
    },
    certificate_expire: { required: requiredIf(() => context.accreditationType === 'secondary') }
  }
}

export const existCAB = context => {
  return {
    certificate_number: {
      required: requiredIf(() => context.existing_CAB.is_active),
      accreditationCertificateNumber
    },
    certificate_date: { required: requiredIf(() => context.existing_CAB.is_active) }
  }
}

export const statementNAAU = context => {
  return {
    CAB_number: { required },
    full_name_director_NAAU: { required },
    name_cab: { required },
    name_applicant: { required },
    accreditation_requirements: { required },
    accreditation_type: { required },
    full_name_CAB: { required },
    short_name_legal: { required },
    legal_address: { required },
    phone: { required, numeric },
    email: { required, email },
    head_applicant: {
      position: { required },
      last_name: { required },
      first_name: { required },
      middle_name: { required }
    },
    head_CAB: {
      last_name: { required },
      first_name: { required },
      middle_name: { required }
    },
    staff_count: {
      employee: { required, numeric },
      freelance: { required, numeric }
    },
    separate_divisions: { required: requiredIf(() => context.hasSeparateDivisions) },
    availability_stations: { required: requiredIf(() => context.hasAvailabilityStations) },
    bank: {
      iban: { required },
      name: { required },
      edrpou: { required },
      ipn: { required, numeric },
      payer: { required }
    }
  }
}

export const surveyNAAU = {
  name_applicant_ukr: { required },
  name_applicant_eng: { required },
  statutory_document: { required },
  legal: {
    address: { required },
    phone: { required, numeric },
    fax: { numeric },
    email: { required, email },
    location: { required }
  },
  ownership: { required },
  governing_body: { required },
  cab_separate: { required },
  own_technical_base: { required },
  amount_work: { required, numeric },
  preliminary_estimation: { required }
}

export const contactPerson = {
  last_name: { required },
  first_name: { required },
  middle_name: { required },
  position: { required },
  phone: { required, numeric },
  fax: { numeric },
  email: { required, email }
}

export const qualityPerson = {
  phone: { numeric },
  fax: { numeric },
  email: { email }
}

export const cabAddress = {
  address: { required }
}

export const accountantPerson = {
  last_name: { required },
  first_name: { required },
  middle_name: { required },
  position: { required },
  phone: { required, numeric },
  fax: { numeric },
  email: { required, email }
}

export const laboratoryCooperation = {
  edrpou: { required, numeric },
  name: { required },
  address: { required },
  district: { required },
  certificate: { required },
  expiration_date: { required }
}

export const certificate = {
  accreditation_body: { required },
  date_start: { required },
  expiration_date: { required },
  certificate_type: { required }
}

export const passportLaboratory = {
  laboratory: {
    name: { required },
    address: { required }
  },
  head_applicant: {
    first_name: { required },
    last_name: { required },
    middle_name: { required },
    position: { required },
    phone: { required, numeric },
    email: { required, email }
  },
  head_laboratory: {
    first_name: { required },
    last_name: { required },
    middle_name: { required },
    position: { required },
    phone: { required, numeric },
    email: { required, email }
  }
}

export const otherContactPerson = {
  first_name: { required },
  last_name: { required },
  middle_name: { required },
  position: { required },
  phone: { required, numeric },
  email: { required, email }
}

export const passportSubLaboratory = {
  name: { required },
  address: { required }
}

export const nomenclatureForm = {
  name: { required },
  dkpp: { required },
  marking: { required }
}

export const testForm = {
  name: { required },
  marking: { required }
}

export const equipment = {
  name: { required },
  test_name: { required },
  manufacturer: { required },
  technical_characteristics: { required },
  commissioning_year: { required, numeric },
  calibration_interval: { required }
}

export const measuring = {
  name: { required },
  characteristic_name: { required },
  manufacturer: { required },
  technical_characteristics: { required },
  commissioning_year: { required, numeric },
  calibration_interval: { required }
}

export const standard = {
  name: { required },
  marking: { required },
  min_calibration: { required },
  tolerance_calibration: { required },
  regulatory_document: { required },
  expiration_date: { required }
}

export const staff = {
  first_name: { required },
  last_name: { required },
  middle_name: { required },
  position: { required },
  education: { required },
  type_work: { required }
}

export const productionPremises = {
  purpose_premises: { required },
  premises_type: { required },
  square: { required },
  temperature: { required },
  humidity: { required },
  lighting: { required },
  gassiness: { required },
  noise: { required },
  obstacle: { required },
  special_equipment: { required },
  ease_delivery: { required },
  acceptance_and_storage: { required }
}

export const testMethod = {
  name: { required },
  approval_date: { required },
  update_date: { required }
}

export const instruction = {
  name: { required },
  create_date: { required },
  approval_date: { required },
  update_date: { required }
}

export const subOrganization = {
  name: { required },
  test_type: { required }
}

export const comparisonProgram = {
  provider: { required },
  test_name: { required },
  date: { required },
  result: { required }
}

export const scopeAccreditation = {
  laboratory_name: { required }
}
export const scopeAccreditationForm = {
  name: { required },
  test_name: { required },
  designation_documents: { required }
}

export const testingLaboratory = {
  name: { required },
  marking: { required },
  product: { required },
  regulatory_document: { required }
}

export const questionnaire = {
  applicant: {
    name: { required },
    address: { required },
    phone: { required, numeric },
    fax: { numeric },
    email: { required, email }
  },
  questionnaire_person: {
    last_name: { required },
    first_name: { required },
    middle_name: { required },
    organization: { required },
    address: { required },
    phone: { required, numeric },
    fax: { numeric },
    email: { required, email }
  },
  generalized_accreditation: { required },
  questionnaire: {
    $each: {
      value: { required }
    }
  }
}

export const testMethodName = {
  test_method_name: { required }
}

export const addNewSectionLaboratory = {
  section_number: { required },
  section_address: { required }
}

export const evaluationTest = {
  method_name: { required },
  test_name: { required },
  object_name: { required },
  standard_develop: { required },
  instruction: { required }
}

export const sectionLaboratory = {
  executor: { required },
  equipment_testing: { required },
  test_location: { required },
  methods_ensuring: { required },
  comparison: { required },
  method_verification_data: { required }
}

export const windowLightTransmissionCertification = context => {
  return {
    measurement_1: {
      required: requiredIf(() => context.window.in_driver_overview ||
        (context.isInspectionTechnicalControl && [1, 3, 4].includes(context.window.window_type))),
      regexNumericDot,
      minValue: minValue(0),
      maxValue: maxValue(100)
    },
    measurement_2: {
      required: requiredIf(() => context.window.in_driver_overview ||
        (context.isInspectionTechnicalControl && [1, 3, 4].includes(context.window.window_type))),
      regexNumericDot,
      minValue: minValue(0),
      maxValue: maxValue(100)
    },
    measurement_3: {
      required: requiredIf(() => context.window.in_driver_overview ||
        (context.isInspectionTechnicalControl && [1, 3, 4].includes(context.window.window_type))),
      regexNumericDot,
      minValue: minValue(0),
      maxValue: maxValue(100)
    }
  }
}

export const inspectionLightTransmissionOtk = {
  windshield_1: { required, numeric, minValue: minValue(0), maxValue: maxValue(100) },
  windshield_2: { required, numeric, minValue: minValue(0), maxValue: maxValue(100) },
  windshield_3: { required, numeric, minValue: minValue(0), maxValue: maxValue(100) },
  back_window_1: { numeric, minValue: minValue(0), maxValue: maxValue(100) },
  back_window_2: { numeric, minValue: minValue(0), maxValue: maxValue(100) },
  back_window_3: { numeric, minValue: minValue(0), maxValue: maxValue(100) }
}

export const windowLightTransmissionOtk = context => {
  return {
    left: {
      1: { required: requiredIf(() => context.itemKey === 1), numeric, minValue: minValue(0), maxValue: maxValue(100) },
      2: { required: requiredIf(() => context.itemKey === 1), numeric, minValue: minValue(0), maxValue: maxValue(100) },
      3: { required: requiredIf(() => context.itemKey === 1), numeric, minValue: minValue(0), maxValue: maxValue(100) }
    },
    right: {
      1: { required: requiredIf(() => context.itemKey === 1), numeric, minValue: minValue(0), maxValue: maxValue(100) },
      2: { required: requiredIf(() => context.itemKey === 1), numeric, minValue: minValue(0), maxValue: maxValue(100) },
      3: { required: requiredIf(() => context.itemKey === 1), numeric, minValue: minValue(0), maxValue: maxValue(100) }
    }
  }
}

export const brakeMeasurement = {
  body: context => {
    return {
      type: { required },
      main_triggering_time: { required, regexNumericDot, minValue: minValue(0) },
      main_brake_specific_force: { required, regexNumericDot, minValue: minValue(0) },
      main_brake_control_force: {
        required: requiredIf(() => !context.body.main_brake_force_without_control),
        regexNumericDot,
        minValue: minValue(0)
      },
      control_type: { required: requiredIf(() => !context.body.without_parking_brake_system) },
      specific_force: {
        required: requiredIf(() => !context.body.without_parking_brake_system),
        regexNumericDot,
        minValue: minValue(0)
      },
      control_brake_force: {
        required: requiredIf(() => !context.disabledControlBrakeForce && !context.body.without_parking_brake_system),
        regexNumericDot,
        minValue: minValue(0)
      }
    }
  },
  axis: context => {
    return {
      irregularity_coeff: { required, regexNumericDot, minValue: minValue(0) },
      ellipticity_left: {
        required: requiredIf(() => context.isShowEllipticity),
        regexNumericDot, minValue: minValue(0)
      },
      ellipticity_right: {
        required: requiredIf(() => context.isShowEllipticity),
        regexNumericDot, minValue: minValue(0)
      },
    }
  },
  parameters: { // для автоматичних
    type: { required },
    control_type: { required }
  }
}

export const lightMeasurement = context => {
  return {
    distance_for_normative: { required, regexNumericDot, minValue: minValue(0), maxValue: maxValue(2147483647) },
    corner_inclination_left: { required, regexNumericDot, minValue: minValue(0) },
    corner_inclination_right: {
      required: requiredIf(() =>
        !context.isOneDippedBeamHeadlight(
          context.$props.vehicleInspectionHeadlights,
          context.isLCategory(context.$props.idVehicleCategory)
        )
      ),
      regexNumericDot,
      minValue: minValue(0)
    },
    left_light_power: { required, regexNumericDot, minValue: minValue(0) },
    right_light_power: {
      required: requiredIf(() =>
        !context.isOneHighBeamHeadlightForLCategory(
          context.$props.vehicleInspectionHeadlights,
          context.isLCategory(context.$props.idVehicleCategory)
        )
      ),
      regexNumericDot,
      minValue: minValue(0)
    },
    headlight_type: { required },
    fog_distance_for_normative: {
      required: requiredIf(() => !context.showFogLight(context.$props.idVehicleCategory) && !context.missing_fog_light),
      regexNumericDot,
      minValue: minValue(0),
      maxValue: maxValue(2147483647)
    },
    fog_light_corner_left: {
      required: requiredIf(() => !context.showFogLight(context.$props.idVehicleCategory) && !context.missing_fog_light),
      regexNumericDot,
      minValue: minValue(0)
    },
    fog_light_corner_right: {
      required: requiredIf(() =>
        !context.showFogLight(context.$props.idVehicleCategory) &&
        !context.missing_fog_light &&
        !context.isOneFogHeadlightForLCategory(
          context.$props.vehicleInspectionHeadlights,
          context.isLCategory(context.$props.idVehicleCategory)
        )
      ),
      regexNumericDot,
      minValue: minValue(0)
    },
    fog_light_left: {
      required: requiredIf(() => !context.showFogLight(context.$props.idVehicleCategory) && !context.missing_fog_light),
      regexNumericDot,
      minValue: minValue(0)
    },
    fog_light_right: {
      required: requiredIf(() =>
        !context.showFogLight(context.$props.idVehicleCategory) &&
        !context.missing_fog_light &&
        !context.isOneFogHeadlightForLCategory(
          context.$props.vehicleInspectionHeadlights,
          context.isLCategory(context.$props.idVehicleCategory)
        )
      ),
      regexNumericDot,
      minValue: minValue(0)
    },
    low_light_power_beam_left: { required, regexNumericDot, minValue: minValue(0) },
    low_light_power_beam_right: {
      required: requiredIf(() =>
        !context.isOneDippedBeamHeadlight(
          context.$props.vehicleInspectionHeadlights,
          context.isLCategory(context.$props.idVehicleCategory)
        )
      ),
      regexNumericDot,
      minValue: minValue(0)
    },
    high_light_power_beam_left: { required, regexNumericDot, minValue: minValue(0) },
    high_light_power_beam_right: {
      required: requiredIf(() =>
        !context.isOneDippedBeamHeadlight(
          context.$props.vehicleInspectionHeadlights,
          context.isLCategory(context.$props.idVehicleCategory)
        )
      ),
      regexNumericDot,
      minValue: minValue(0)
    }
  }
}

export const gasMeasurement = context => {
  return {
    neutralizer: {
      required: requiredIf(() => context.showNeutralizerTechnicalControl || !context.isInspectionTechnicalControl)
    },
    r_min_lambda: {
      required: requiredIf(() => context.isInspectionTechnicalControlAndAboveDates),
      regexNumericDot
    },
    r_min_co_level: { required, regexNumericDot, minValue: minValue(0) },
    r_min_ch_level: { required: requiredIf(() => context.showChLevel), regexNumericDot, minValue: minValue(0) },
    r_min_temperature: { required, regexNumericDot, minValue: minValue(0) },
    r_min_rpm: { required, regexNumericDot, minValue: minValue(0) },
    r_max_lambda: {
      required: requiredIf(() => context.isInspectionTechnicalControlAndAboveDates),
      regexNumericDot
    },
    r_max_co_level: { required, regexNumericDot, minValue: minValue(0) },
    r_max_ch_level: { required: requiredIf(() => context.showChLevel), regexNumericDot, minValue: minValue(0) },
    r_max_temperature: { required, regexNumericDot, minValue: minValue(0) },
    r_max_rpm: { required, regexNumericDot, minValue: minValue(0) }
  }
}

export const smokeMeasurement = {
  measurement: {
    absorption_level_1: { required, regexNumericDot, minValue: minValue(0) },
    absorption_level_2: { required, regexNumericDot, minValue: minValue(0) },
    absorption_level_3: { required, regexNumericDot, minValue: minValue(0) },
    absorption_level_4: { required, regexNumericDot, minValue: minValue(0) },
    absorption_level: { required, regexNumericDot, minValue: minValue(0) },
    temperature: { required, regexNumericDot, minValue: minValue(0) }
  },
  smokiness_limit_indicator: { regexNumericDot, minValue: minValue(0) }
}

export const noiseMeasurement = {
  external_noise: { required, regexNumericDot, minValue: minValue(0) },
  measurement_mode: { required, regexNumericDot, minValue: minValue(0) },
  noise_measurements: {
    additionalProp1: { required, regexNumericDot, minValue: minValue(0) },
    additionalProp2: { required, regexNumericDot, minValue: minValue(0) },
    additionalProp3: { required, regexNumericDot, minValue: minValue(0) }
  }
}

export const checkEquipment = context => {
  return {
    is_availability: {
      required: requiredIf(() => context.item.required),
      checkAvailable: onlyTrue(context.item.required)
    },
    equipment: {
      name: { required: requiredIf(() => context.item.is_availability && context.item.required) },
      country: { required: requiredIf(() => context.item.is_availability && context.item.required) }
    },
    calibration: {
      date: { required: requiredIf(() => context.item.is_calibrated && context.item.required) },
      interval: {
        required: requiredIf(() => context.item.is_calibrated && context.item.required),
        numeric
      }
    }
  }
}

export const issuingCertificate = {
  euro_code: { required },
  legal_act_for_euro_rate: { required }
}

export const answer = context => {
  return {
    answer_text: {
      required: requiredIf(() => context.answer !== 'Not use for this vehicle'),
      maxLength: maxLength(30)
    }
  }
}

export const exceptionCode = {
  exception_codes: { required }
}

export const accountOC = {
  createAccount: context => {
    return {
      date_birth: {
        required,
        minValue (value) {
          if (context.isPassportBook) {
            return new Date(value) > new Date('1900-01-01')
          } else {
            return context.age >= 14
          }
        },
        maxValue (value) { return new Date(value) < new Date() }
      },
      first_name: { required, regexLetters },
      middle_name: { regexLetters },
      last_name: { required, regexLetters },
      email: { required, email },
      user_passports: {
        serial: { 
          required,
          ...(context.isPassportBook ? { regexLetterNumber } : { regexLetterNumberEng }),
          maxLength: maxLength(20) 
        },
        inn: {
          required: requiredIf(() => !context.isNoITN),
          numeric,
          innLength
        },
        date_start: {
          required,
          minValue (value) {
            return new Date(value) > new Date('1920-01-01') && new Date(value) > new Date(context.body.date_birth)
          },
          maxValue (value) {
            return new Date(value) < new Date('2100-01-01')
          }
        },
        date_end: {
          minValue (value) {
            if (!context.isPassportBook && value) {
              return new Date(value) > new Date('1920-01-01') &&
                new Date(value) > new Date(context.body.user_passports.date_start)
            }
            return true
          },
          maxValue (value) {
            if (!context.isPassportBook && value) {
              return new Date(value) < new Date('2100-01-01')
            }
            return true
          },
          invalidPassport (value) {
            if (!context.isPassportBook && value) {
              return new Date(value) >= new Date()
            }
            return true
          }
        }
      }
    }
  },

  updateAccount: context => {
    return {
      first_name: { required, regexLetters },
      middle_name: { required, regexLetters },
      last_name: { required, regexLetters },
      email: { required, email },
      user_passports: {
        serial: {
          required,
          regexLetterNumber,
          maxLength: maxLength(20)
        },
        inn: {
          required: requiredIf(() => context.isRequiredItn),
          numeric,
          innLength
        },
      }
    }
  },

  registrationOC: {
    mainInfo: {
      body: {
        checkbox: {
          is_legal_entity: { required: sameAs(() => true) },
          you_are_accredited_by_law: { required: sameAs(() => true) }
        },
        name: { required, nameOrganization },
        short_name: { required, nameOrganization },
        EDPROU: { required, numeric, minLength: minLength(8), maxLength: maxLength(8) },
        accreditation_certificate_number: { required, accreditationCertificateNumber, maxLength: maxLength(15) },
        order_number: { required, orderNumber, maxLength: maxLength(5) },
        order_date: {
          required,
          invalidFormat,
          maxValue (value) { return new Date(value) <= new Date() }
        },
        accreditation_certificate_date_start: {
          required,
          invalidFormat,
          maxValue (value) { return new Date(value) <= new Date() }
        },
        accreditation_certificate_date_end: {
          required,
          invalidFormat,
          minValue (value) { return new Date(value) > new Date() }
        },
        code: { required, maxLength: maxLength(20) },
        allow_categories: { required },
        landline_phone: { minLength: minLength(13) },
        email: { required, email },
        web_resource_link: { required, url }
      }
    },

    addEmployee: {
      body: {
        checkbox: {
          do_you_have_employees: { required: sameAs(() => true) }
        }
      },
      form: context => {
        return {
          statement_employee_status: { required },
          last_name: { required, regexLetters },
          first_name: { required, regexLetters },
          middle_name: { required, regexLetters },
          serial: { required, regexLetterNumber },
          inn: { required, numeric, innLength },
          position: { required, maxLength: maxLength(50) },
          email: { required: requiredIf(() => context.body.statement_employee_status === 1), email },
          password: {
            required: requiredIf(() => context.body.statement_employee_status === 1 && !context.isReprocessing),
            maxLength: maxLength(20)
          },
          education_document_number: { required, maxLength: maxLength(100) },
          education_document_issued_date: { required },
          educational_institution: { required },
          specialization: { required, maxLength: maxLength(100) },
          direction_raising_qualification: { required, maxLength: maxLength(100) },
          raising_qualification_document_number: { required, maxLength: maxLength(100) },
          raising_qualification_date: { required },
          experience_years: { required, numeric, maxLength: maxLength(2) }
        }
      }
    },

    editEmployee: context => {
      return {
        email: { required: requiredIf(() => context.body.statement_employee_status === 1), email },
        password: {
          required: requiredIf(() => context.body.statement_employee_status === 1),
          maxLength: maxLength(20)
        },
        direction_raising_qualification: { required },
        raising_qualification_document_number: { required },
        raising_qualification_date: { required },
        experience_years: { required, numeric }
      }
    },

    questionsAndDocuments: context => {
      if (context.isReprocessing) {
        return {
          checkbox: {
            insurance_contract: { required: sameAs(() => true) },
          },
          type_insurance: { required },
          sum_insurance_fund: {
            required: requiredIf(() => context.body.type_insurance === 0),
            numeric,
            maxValue: maxValue(2147483647)
          },
          number_insurance_contract: { required: requiredIf(() => context.body.type_insurance === 1), orderNumber },
          end_date_insurance_contract: { required: requiredIf(() => context.body.type_insurance === 1), invalidFormat },
        }
      } else {
        return {
          checkbox: {
            do_you_have_labs: { required: sameAs(() => true) },
            three_years_of_work_experience: { required: sameAs(() => true) },
            dependence_on_the_customer: { required: sameAs(() => true) },
            insurance_contract: { required: sameAs(() => true) },
            information_confidentiality_requirements: {
              required: requiredIf(() => context.body.checkbox.information_confidentiality_requirements === null)
            }
          },
          type_insurance: { required },
          sum_insurance_fund: {
            required: requiredIf(() => context.body.type_insurance === 0),
            numeric,
            maxValue: maxValue(2147483647)
          },
          number_insurance_contract: { required: requiredIf(() => context.body.type_insurance === 1), orderNumber },
          end_date_insurance_contract: { required: requiredIf(() => context.body.type_insurance === 1), invalidFormat },
          violation: { required }
        }
      }
    }
  },

  updateInfoOC: context => {
    return {
      name: { required, nameOrganization },
      short_name: { required, nameOrganization },
      EDPROU: { required, numeric, minLength: minLength(8), maxLength: maxLength(8) },
      accreditation_certificate_number: { required, accreditationCertificateNumber, maxLength: maxLength(15) },
      order_number: { required, orderNumber, maxLength: maxLength(5) },
      order_date: {
        required,
        invalidFormat,
        maxValue (value) { return new Date(value) <= new Date() }
      },
      accreditation_certificate_date_start: {
        required,
        invalidFormat,
        maxValue (value) { return new Date(value) <= new Date() }
      },
      accreditation_certificate_date_end: {
        required,
        invalidFormat,
        minValue (value) { return new Date(value) > new Date() }
      },
      code: { required, maxLength: maxLength(20) },
      allow_categories: { required },
      landline_phone: { minLength: minLength(13) },
      email: { required, email },
      web_resource_link: { required, url },
      type_insurance: { required },
      sum_insurance_fund: { required: requiredIf(() => context.body.type_insurance === 0), numeric },
      number_insurance_contract: { required: requiredIf(() => context.body.type_insurance === 1), orderNumber },
      end_date_insurance_contract: { required: requiredIf(() => context.body.type_insurance === 1), invalidFormat }
    }
  },

  branch: {
    address: { required, address },
    head_full_name: { required },
    email: { required, email }
  }
}

export const employeesOC = context => {
  return {
    last_name: { required, regexLetters },
    first_name: { required, regexLetters },
    middle_name: { required, regexLetters },
    position: { required, regexLetters },
    email: { required, email },
    phone_number: { required },
    type_user: { required },
    password: {
      required: requiredIf(() => context.isAddEmployee),
      maxLength: maxLength(20)
    }
  }
}

export const accountOCcooperation = context => {
  return {
    name: { required },
    EDPROU: { required, numeric, minLength: minLength(8), maxLength: maxLength(8) },
    organization_name: { required },
    address: { required },
    contract_start_date: { required, invalidFormat },
    contract_end_date: {
      required,
      minValue (value) {
        return new Date(value) > new Date(context.body.contract_start_date)
      },
      invalidFormat
    }
  }
}

export const accountVL = {
  registrationVL: {
    name: { required, nameOrganization },
    short_name: { required, nameOrganization },
    EDPROU: { required, numeric, minLength: minLength(8), maxLength: maxLength(8) },
    landline_phone: { minLength: minLength(13) },
    email: { required, email },
    web_resource_link: { url },
    accreditation_certificate_number: { required, accreditationCertificateNumber, maxLength: maxLength(15) },
    accreditation_certificate_date_end: {
      required,
      minValue (value) {
        return new Date(value) > new Date()
      }
    }
  },

  branch: {
    name: { required, orderNumber },
    number: { required, numeric, maxValue: maxValue(20) },
    allow_categories: { required }
  },

  contract: {
    EDPROU: { required, numeric, minLength: minLength(8), maxLength: maxLength(8) },
    name: { required },
    contract_start_date: { required },
    contract_end_date: { required },
  }
}

export const equipmentBranch = context => {
  return {
    passport_number: {
      required: requiredIf(() => context.isRequired)
    },
    serial_number: {
      required: requiredIf(() => context.isRequired)
    },
    date_previous_verification: {
      required: requiredIf(() => context.isRequired),
      maxValue (value) {
        if (context.body.date_next_verification) {
          return new Date(value) < new Date(context.body.date_next_verification) && new Date(value) < new Date()
        } else return true
      },
      invalidFormat
    },
    date_next_verification: {
      required: requiredIf(() => context.isRequired),
      /**
       * TEMP disabled minValue validation for date_next_verification
       * if you need to enable it, uncomment the code below
      */
      // minValue (value) {
      //   if (context.body.date_previous_verification) {
      //     return new Date(value) > new Date(context.body.date_previous_verification) && new Date(value) > new Date()
      //   } else return true
      // },
      invalidFormat
    },
    equipment_model: {
      required: requiredIf(() => context.isRequired)
    }
  }
}

export const transferableNumber = {
  transferable_number: { regexNumericDot }
}

export const branchUser = context => {
  return {
    first_name: { required, regexLetters },
    last_name: { required, regexLetters },
    middle_name: { required, regexLetters },
    type_user: { required },
    position: { required, maxLength: maxLength(50) },
    email: {
      required: requiredIf(() => !context.body.id),
      email
    },
    phone_number: { required },
    password: {
      required: requiredIf(() => !context.body.id),
      maxLength: maxLength(20)
    }
  }
}

export const educationUser = {
  type_education_document: {
    required
  },
  educational_institution: {
    required,
    maxLength: maxLength(100)
  },
  number: {
    required,
    minLength: minLength(1),
    maxLength: maxLength(100)
  },
  issued_date: { required },
  speciality: {
    required,
    minLength: minLength(1),
    maxLength: maxLength(100)
  }
}

export const branchUserPassport = {
  serial: {
    required,
    regexLetterNumber
  },
  inn: {
    required,
    numeric,
    innLength
  }
}

export const technicalControlInspection = {
  body: context => {
    return {
      vehicle_color: { required },
      load_capacity: {
        required: requiredIf(() => context.showLoadCapacityFotTechnicalControl(context.body.vehicle.vehicle_category)),
        numeric
      },
      special_purpose: { required: requiredIf(() => context.body.special_purpose !== null) },
      vehicle_mileage: { required: requiredIf(() => !context.ktzIsOCategory), numeric },
      previous_vehicle_mileage: { required: requiredIf(() => !context.ktzIsOCategory), numeric },
      has_turbine_or_compressor: { required: requiredIf(() => !context.ktzIsOCategory) },
      first_registration_date: { required, invalidFormat },
      government_registration_date: {
        required,
        invalidFormat,
        minValue (value) { return new Date(value) >= new Date(context.body.first_registration_date) }
      },
      vehicle: {
        vehicle_category: { required },
        vehicle_mark: { required },
        vehicle_model: { required: requiredIf(() => !context.isKtzWithoutModel) },
        vehicle_modification: { required: requiredIf(() => context.vehicleModifications.length) },
        fuel_type: { required: requiredIf(() => !context.ktzIsOCategory) },
        count_cylinders: {
          required: requiredIf(() => !context.ktzIsOCategory),
          numeric
        },
        engine_rpm: {
          required: requiredIf(() => !context.ktzIsOCategory),
          numeric,
          maxValue: maxValue(30000)
        },
        engine_euro_rate: { required: requiredIf(() => !context.ktzIsOCategory) },
        production_year: {
          required,
          numeric,
          minValue (value) { return new Date(value.toString()) >= new Date('1988') },
          maxValue (value) { return new Date(value.toString()) <= new Date() },
          minLength: minLength(4)
        },
        weight: { required, numeric, maxValue: maxValue(999999) },
        engine_power: {
          required: requiredIf(() => !context.ktzIsOCategory),
          numeric,
          maxValue: maxValue(9999)
        },
        count_axles: { required, numeric },
        count_silencers: {
          required: requiredIf(() => !context.ktzIsOCategory),
          numeric,
          maxValue: maxValue(20)
        },
        width: { numeric },
        length: { numeric }
      },
      weather_temperature: { required, floatNumber },
      weather_pressure: { required, regexNumericDot },
      weather_humidity: { required, numeric },
      weather_wind_speed: { required, numeric }
    }
  },
  conversion: {
    name: { required },
    date: { required, invalidFormat },
    number: { required, orderNumber },
    description: { required }
  },
  remarkAndThoughts: {
    rejected_decision: { nameOrganization },
    thoughts: { nameOrganization }
  }
}

export const identificationAct = {
  reason: { required }
}

export const typePassport = context => {
  const notPermitResidence = context.type_passport !== 'Permit for residence'
  return {
    serial: {
      required: requiredIf(() => context.isRequiredInputs),
      serial,
      minLength: minLength(context.lengthDocumentNumber),
      maxLength: maxLength(context.lengthDocumentNumber)
    },
    date_start: {
      required: requiredIf(() => context.isRequiredInputs && notPermitResidence),
      minValue (value) {
        if (context.isRequiredInputs && notPermitResidence) {
          return new Date(value) > new Date('1920-01-01') && new Date(value) > new Date(context.dateBirth)
        }
        return true
      },
      maxValue (value) {
        if (context.isRequiredInputs && notPermitResidence) {
          return new Date(value) < new Date('2100-01-01')
        }
        return true
      }
    },
    date_end: {
      required: requiredIf(() => context.type_passport === 'Permit for residence'),
      minValue (value) {
        if (context.isNotPaperPassport && context.isRequiredInputs && value && notPermitResidence) {
          return new Date(value) > new Date('1920-01-01') && new Date(value) > new Date(context.date_start)
        }
        return true
      },
      maxValue (value) {
        if (context.isNotPaperPassport && context.isRequiredInputs && value) {
          return new Date(value) < new Date('2100-01-01')
        }
        return true
      },
      invalidPassport (value) {
        if (context.isNotPaperPassport && context.isRequiredInputs && value) {
          return new Date(value) >= new Date()
        }
        return true
      }
    },
    personal_number: {
      required: requiredIf(() => ['International passport', 'Permit for residence'].some(i => i === context.type_passport)),
      minLength: minLength(context.type_passport === 'Permit for residence' ? 14 : 0),
      maxLength: maxLength(context.type_passport === 'Permit for residence' ? 14 : 14)
    },
    issued_department: {
      required: requiredIf(() => [
        context.identityDocument.idCard,
        context.identityDocument.internationalPassport,
        context.identityDocument.permitForResidence
      ].some(i => i === context.type_passport)),
      minLength: minLength(4),
      maxLength: maxLength(4),
      numeric
    },
    nationality: {
      required: requiredIf(() => context.type_passport === 'Permit for residence'),
      regexLetters,
      maxLength: maxLength(3)
    }
  }
}

export const changeResponsiblePerson = {
  person: { required }
}

export const inquiryTechSupport = {
  statement_number: { numeric },
  error_url: { url },
  additional_email: { email },
  text: { required }
}

export const declarationNumber = {
  number: { required }
}

export const noiseEquipment = {
  equipment: { required },
  measurement_mode: { required },
  external_noise: { required },
  noise_standard: { required },
}

export const vinCodeField = context => {
  return {
    required,
    regexVinCode: context.isVinCodeNonStandardLength ? regexNoSpace : regexVinCode,
    minLength: minLength(context.isVinCodeNonStandardLength ? 5 : 17),
    maxLength: maxLength(context.isVinCodeNonStandardLength ? 23 : 17)
  }
}

export const additionalVinCode = context => {
  return {
    required: requiredIf(() => context.isVinCodeDifferent),
    regexVinCode,
    minLength: minLength(9),
    maxLength: maxLength(12)
  }
}

export const ruleBaseSetting = {
  complete_type: { required },
  vehicle_category: { required }
}

export const manualCertificate = {
  vehicle: {
    vehicle_mark_type: { required },
    vehicle_variant: { required },
    vehicle_version: { required },
    vehicle_mark: { required },
    vehicle_model: { required },
    manufacturer_country: { required },
    identification_method: { required },
    identification_place: { required },
  },
  basic_certificate_number: { maxLength: maxLength(30) },
  modification_approval_issuer: { maxLength: maxLength(50) },
  modification_approval_document_number: { maxLength: maxLength(50) }
}

export const startCertificateNumber = {
  start_certificate_number: { required, numeric }
}

export const equipmentForCalibration = {
  equipment: { required }
}

export const smokeInspection = {
  cycle_type: { required },
}

export const noiseInspection = {
  inspection_type: { required },
  measurement_mode: { required },
  noise_measurement_result: { required, numeric },
}

export const inspectionTypeMeasurement = {
  inspection_type: { required },
  co: { required, numeric },
  nox: { required, numeric },
}

export const changePasswordForm = context => {
  return {
    old_password: {
      required: requiredIf(() => !context.recoveryPass)
    },
    new_password: { required, minLength: minLength(8), maxLength: maxLength(128) },
    confirm_password: { required, samePassword: sameAs('new_password') }
  }
}

export const finalizationInspection = {
  required,
  maxLength: maxLength(400)
}

export const addDocumentNumber = context => {
  if (context.$props.isOnlyNumbers) {
    return {
      required,
      numeric,
      maxLength: maxLength(10)
    }
  } else {
    return {
      required,
      maxLength: maxLength(50)
    }
  }
}

export const addNewCity = {
  region: { required },
  city_type: { required },
  name: { required, regexLetters }
}
